<template>
  <div class="select-card-modal">
    <el-dialog title="选择推广卡片" :visible.sync="dialogVisible" width="916px" :append-to-body="true">
      <div class="modal-body">
        <div class="filter-header">
          <el-input placeholder="请输入组件名称" prefix-icon="el-icon-search" v-model="component_name" class="filter-select"> </el-input>
          <el-select v-model="status" multiple placeholder="请选择" class="filter-select">
            <el-option label="通过" value="PASS "></el-option>
            <el-option label="审核中" value="UNDER"></el-option>
            <el-option label="未通过" value="REJECT"></el-option>
          </el-select>
        </div>
        <div class="content-body">
          <div
            :class="['item-card', curData && item.component_id === curData.component_id ? 'cur' : '']"
            v-for="item of dataList"
            :key="item.component_id"
            @click="curData = item"
          >
            <div class="top-banner">
              <img class="img-wrap" :src="item.image_url" />
              <div class="text-wrap">
                <div class="top-text">{{ item.component_data.title }}</div>
                <div class="bottom-text">{{ item.component_data.product_selling_points[0] }}</div>
              </div>
              <span class="download-icon">立即下载</span>
            </div>
            <div class="card-header">
              <span class="card-name">{{ item.component_name }}</span>
              <span class="card-type pass" v-if="item.status === 'PASS'">通过</span>
              <span class="card-type under" v-else-if="item.status === 'UNDER'">审核中</span>
              <span class="card-type reject" v-else-if="item.status === 'REJECT'">未通过</span>
            </div>
            <div class="card-id">{{ item.component_id }}</div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { promotionCard } from "@/api/promotion.js";
export default {
  name: "SelectCardModal",
  data() {
    return {
      dialogVisible: false,
      component_name: "",
      status: [],
      curAdvertiserId: null,
      dataList: [],
      curData: null,
    };
  },
  methods: {
    confirmData() {
      if (!this.curData) {
        this.$message({
          message: "请选择推广卡片",
          type: "warning",
        });
      } else {
        this.$emit("cardSelectOk", {
          cardData: this.curData,
          advertiserId: this.curAdvertiserId,
        });
        this.dialogVisible = false;
      }
    },
    searchData(advertiserId) {
      this.curAdvertiserId = advertiserId;
      promotionCard({
        advertiserId: advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.dataList = res.creativeComponentList;
        }
      });
    },
    showModal(countData) {
      this.dialogVisible = true;
      this.searchData(countData.advertiserId);
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .filter-header {
    margin-bottom: 12px;
    .filter-select {
      width: 200px;
      margin-right: 12px;
      /deep/ .el-icon-search {
        position: relative;
        top: -3px;
      }
    }
  }
  .content-body {
    height: 350px;
    overflow: auto;
    padding: 12px 0;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .item-card {
      width: 270px;
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 10px;
      // height: 62px;
      box-sizing: border-box;
      flex-shrink: 0;
      cursor: pointer;
      margin: 0 12px 12px 0;
      &:hover {
        border: 1px solid #ddd;
      }
      &.cur {
        border: 1px solid #409eff;
      }
      .top-banner {
        background: #464649;
        border-radius: 4px;
        display: flex;
        align-items: center;
        height: 50px;
        padding: 10px;
        box-sizing: border-box;
        .img-wrap {
          width: 30px;
          height: 30px;
          flex-shrink: 0;
          border: 1px solid #666;
          margin-right: 10px;
        }
        .text-wrap {
          font-size: 12px;
          .top-text {
            color: #fff;
          }
          .bottom-text {
            color: #818181;
          }
        }
        .download-icon {
          flex-shrink: 0;
          width: 60px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          background: #ed5085;
          border-radius: 4px;
          margin-left: auto;
        }
      }

      .card-header {
        margin-top: 10px;
        .card-name {
          font-size: 12px;
        }
        .card-type {
          line-height: 20px;
          border-radius: 4px;
          padding: 2px 4px;
          font-size: 12px;
          margin-left: 4px;
          &.pass {
            border: 1px solid #6adea8;
            color: #00b875;
            background: #dff7ea;
          }
          &.under {
            border: 1px solid #91d5ff;
            color: #1890ff;
            background: #e6f7ff;
          }
          &.reject {
            border: 1px solid red;
            color: red;
            background: rgb(255, 230, 230);
          }
        }
      }
      .card-id {
        margin-top: 4px;
        font-size: 12px;
        color: #818181;
      }
    }
  }
}
</style>
